import 'shared/assets/application';
import '../components/footer_bar/footer-bar.scss'
import '../components/resort_contacts/resort_contacts.js';